import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'
import arraySort from 'array-sort'
import ReactTooltip from 'react-tooltip'

import { getTruncatedString } from '../../utils/string'

export default class CourseSelect extends Component {
  constructor (props) {
    super(props)
    this.state = {
      selectedValue: props.course
    }
    this.handleSelectChangeBound = this.handleSelectChange.bind(this)
  }

  render () {
    const { courses, disabled } = this.props

    return (
      <div className="course-select">
        {disabled && <ReactTooltip id="courseSelectTooltip" />}
        <div
          data-for="courseSelectTooltip"
          data-tip="No journeys are available."
        >
          <Select
            ref={this.props.courseFilterRef}
            searchable
            clearable
            options={this.mapList(courses)}
            value={this.state.selectedValue}
            onChange={this.handleSelectChangeBound}
            placeholder={this.props.placeholder || ''}
            disabled={disabled}
            matchProp='label'
          />
        </div>
      </div>
    )
  }

  handleSelectChange (value) {
    this.setState(() => {
      return {
        selectedValue: value
      }
    })
    this.props.onCourseChange(value)
  }

  mapList (arr) {
    const { labelTruncationLength } = this.props
    const values = arr.map(function (course) {
      return {
        id: course.id,
        value: course.id,
        label: getTruncatedString({
          val: course.name,
          len: labelTruncationLength
        }),
        className: 'courseselect-option',
        style: {
          color: `#${course.color}`
        }
      }
    })
    return arraySort(values, ['label'])
  }
}

CourseSelect.propTypes = {
  course: PropTypes.object,
  courses: PropTypes.array.isRequired,
  onCourseChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  courseFilterRef: PropTypes.object,
  labelTruncationLength: PropTypes.number.isRequired,
  placeholder: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/mini/CourseSelect.js